module.exports = __webpack_public_path__ + "static/media/virtual-sprite-student-portal.ea57d2e0.png";